import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './shared/auth/AuthContext'
import './index.css'
import ErrorBoundary from './shared/components/ErrorBoundary'
import { isChunkError, reloadOnce } from './shared/reload'

// A file of the old version failed to load after a deploy -> get the new version (shared/reload.ts)
window.addEventListener('vite:preloadError', (e) => { if (reloadOnce()) e.preventDefault() })
window.addEventListener('unhandledrejection', (e) => { if (isChunkError(e.reason)) reloadOnce() })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
)
